const MESSAGE_TEMPLATE_FIELDS = [
  'id',
  'title',
  'content',
  'category',
  'conditions',
  'pipeline_id',
  'stage_id',
  'created_at',
  'updated_at',
];

const cloneValue = value => {
  if (Array.isArray(value)) return value.map(cloneValue);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [
        key,
        cloneValue(nestedValue),
      ])
    );
  }
  return value;
};

export const serializeMessageTemplate = (
  template,
  { existingTemplate = null, preserveLegacyWebhook = false } = {}
) => {
  const serialized = Object.fromEntries(
    MESSAGE_TEMPLATE_FIELDS.filter(
      field => template?.[field] !== undefined
    ).map(field => [field, cloneValue(template[field])])
  );

  if (
    preserveLegacyWebhook &&
    existingTemplate &&
    Object.prototype.hasOwnProperty.call(existingTemplate, 'webhook')
  ) {
    serialized.webhook = cloneValue(existingTemplate.webhook);
  }

  return serialized;
};

export default serializeMessageTemplate;
